import angular from 'angular';
import { MainMenu, MenuButton } from '@adjust/dashboard-components';
import { registerComponents } from '@lib/react-utils';

import { AppIcon } from '@common/AppIcon/AppIcon';
import Platforms from '@common/Platforms/Platforms';
import { UserDetailsSidebarInternal } from '@react/Pages/AccountSettingsPage/UserDetails/UserDetails/UserDetailsSidebar';
import { UsersPageContainer } from '@react/Pages/UsersPage/UsersPage/UsersPage.container';
import { AccountDataPageContainer } from './Pages/AccountSettingsPage/YourDataSection/AccountDataPage.container';
import { CreditCardFormContainer } from './Pages/PaymentSetup/CreditCardForm/CreditCardForm.container';
import { InvoicesPageContainer } from './Pages/AccountSettingsPage/InvoicesPage/InvoicesPage.container';
import { PricingPlanPageContainer } from './Pages/AccountSettingsPage/PricingPlanPage/PricingPlanPage.container';

export const components = [
  ['accountDataPage', AccountDataPageContainer, ['hrefList']],
  ['appIcon', AppIcon, ['skeletonStyle', 'size', 'appId']],
  ['creditCardForm', CreditCardFormContainer, ['showCancelButton', 'isDarkTheme', 'onCancel', 'onSubmit']],
  ['invoicesPage', InvoicesPageContainer],
  ['platforms', Platforms, ['platforms', 'attributionPlatform', 'hideUnconfigured']],
  ['pricingPlanPage', PricingPlanPageContainer, ['isOnboarding']],
  ['userDetailsSidebar', UserDetailsSidebarInternal],
  [
    'mainMenu',
    MainMenu,
    [
      'currentUser',
      'currentAccount',
      'baseUrl',
      'activeLink',
      'language',
      't',
      'logout',
      'toggleSidebar',
      'accounts',
      'switchAccount',
      'searchAccount',
    ],
  ],
  ['usersPage', UsersPageContainer, ['goTo', 'setQuery']],
  ['menuButton', MenuButton, ['onClick', 'ariaLabel', 'dataTestId']],
];

export default registerComponents(angular.module('adjust.reactModule', []), components);
